import {useJbHttpCrudService} from "../../core/service/jb-http-crud.service";
import {ProcessEntity} from "../../context/admin/module/attendance/domain/entity/process.entity";
import {BaseResponse} from "../../core/common/base-response.common";
import {ResumeProcessItemEntity} from "../entity/resume-process.item.entity";

export function useProcessRepository() {
  const { ...crud  } = useJbHttpCrudService<ProcessEntity>('process');
  
  function attachObject(processId: string, dto: {
    objectId: string,
    type: string,
    probability: number,
    amount: number
  }) {
    return crud.post(
      `${crud.resourceName}/${processId}/add-process-object`,
      JSON.stringify(dto),
    )
  }
  
  function editAttachedObject(
    processId: string,
    objectAttachedId: string,
    dto: {
      type: string,
      probability: number,
      amount: number,
      result: number,
  }) {
    return crud.put(
      `${crud.resourceName}/${processId}/edit-process-object/${objectAttachedId}`,
      JSON.stringify(dto),
    )
  }
  
  function removeAttachedObject(processId: string, objectId: string) {
    return crud.post(
      `${crud.resourceName}/${processId}/remove-process-object/${objectId}`,
      {},
    )
  }
  
  
  function listAttachedObject(processId: string) {
    return crud.get(
      `${crud.resourceName}/${processId}/list-process-objects`,
      {},
    )
  }
  
  function reportResumeProcess(): Promise<BaseResponse<ResumeProcessItemEntity[]>> {
    return crud.get(
      `${crud.resourceName}/report/resume`
    )
  }
  
  
  function downloadReportResumeProcess(): Promise<BaseResponse<ResumeProcessItemEntity[]>> {
    return crud.download({
      uri: `${crud.resourceName}/report/resume/export`,
      method: 'get'
    })
  }
  
  return {
    ...crud,
    attachObject,
    removeAttachedObject,
    listAttachedObject,
    editAttachedObject,
    reportResumeProcess,
    downloadReportResumeProcess,
  }
}
